import { Button, Input } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { VisibilityIcon } from 'BreetAssets';
import { DEFAULT_INPUT_MAX_LENGTH, type IPasswordInput } from 'BreetHelpers';
import { type InvalidEvent, useCallback, useState } from 'react';

const PasswordInput = ({ id, ...rest }: IPasswordInput) => {
	const [showPassword, setShowPassword] = useState<boolean>(false);

	const handlePassword = useCallback(() => {
		setShowPassword((prev) => !prev);
	}, []);

	const onInputInvalid = useCallback((e: InvalidEvent<HTMLInputElement>) => {
		e.preventDefault();
	}, []);

	return (
		<div
			className='password_input'
			data-testid='password-input'
		>
			<Input
				placeholder=' '
				maxLength={DEFAULT_INPUT_MAX_LENGTH}
				{...rest}
				type={showPassword ? undefined : 'password'}
				onInvalid={onInputInvalid}
				id={id ?? ''}
			/>
			<Button
				variant='native'
				type='button'
				className='show-password'
				aria-label={showPassword ? 'Hide password' : 'Show password'}
				aria-pressed={showPassword}
				onClick={handlePassword}
			>
				<VisibilityIcon
					show={!showPassword}
					className={classNameMerger('svg-dark svg-dark-outline', 'cursor_pointer')}
					aria-hidden
				/>
			</Button>
		</div>
	);
};

export default PasswordInput;
